// extracted by mini-css-extract-plugin
export var filterIncDec = "_bu-0";
export var leftBorder = "_bu-1";
export var rightBorder = "_bu-2";
export var stringInput = "_bu-3";